export default __webpack_public_path__ + "static/media/TableActive.e3f4c781.svg";